/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import {
	HubBootstrapWrapperQuery,
	type hubBootstrapWrapperQuery,
	mockHubRouteProps,
} from '@atlassian/company-hub-common';

import { HUB_PREVIEW_ROUTE_NAME } from '../../controllers/constants';
import HubQuery, {
	type hubQuery as hubQueryType,
} from '../../ui/hub/__generated__/hubQuery.graphql';

import { createRelayResource, getPageAri } from './utils';

export const hubBootstrapResource = createRelayResource<hubBootstrapWrapperQuery>({
	getQuery: ({ match, route }, { cloudId, helpCenterAri }) => {
		const isPreview = route?.name === HUB_PREVIEW_ROUTE_NAME;
		const pageId = match.params.id || '';
		let cloudIdDerived = cloudId;
		let helpCenterAriDerived = helpCenterAri;

		if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
			cloudIdDerived = mockHubRouteProps.env.cloudId;
			helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
		}

		return {
			variables: {
				cloudId: cloudIdDerived,
				hubAri: helpCenterAriDerived,
				pageAri: getPageAri(helpCenterAriDerived, pageId),
				operationType: 'READ',
				hubEditMode: false,
			},
			query: HubBootstrapWrapperQuery,
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});

export const hubPageResource = createRelayResource<hubQueryType>({
	getQuery: ({ match, route }, { cloudId, helpCenterAri }) => {
		const isPreview = route?.name === HUB_PREVIEW_ROUTE_NAME;
		const pageId = match.params.id || '';
		let cloudIdDerived = cloudId;
		let helpCenterAriDerived = helpCenterAri;

		if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
			cloudIdDerived = mockHubRouteProps.env.cloudId;
			helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
		}

		return {
			variables: {
				cloudId: cloudIdDerived,
				hubAri: helpCenterAriDerived,
				pageAri: getPageAri(helpCenterAriDerived, pageId),
			},
			query: HubQuery,
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});
